import Img1 from 'assets/images/margin-onboarding-1.png'
import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'

import { Button, ButtonWrapper, ContentWrapper, Description, Img, Title, Wrapper } from './common'

type Props = { onNext: () => void }

const ItsLive = ({ onNext }: Props) => (
  <Wrapper>
    <Img src={Img1} />
    <ContentWrapper>
      <Title>
        <I18n data={messages.margin_onboarding_live_title} />
      </Title>
      <Description>
        <I18n data={messages.margin_onboarding_live_description} />
      </Description>
      <ButtonWrapper>
        <Button onClick={onNext}>
          <I18n data={messages.margin_onboarding_live_cta} />
        </Button>
      </ButtonWrapper>
    </ContentWrapper>
  </Wrapper>
)

export default ItsLive
